import View from '@components/navTab/view.vue';
const name = routerName => `d_${routerName}`;

const trade = {
  path: '/distributor/trade',
  name: name('DistributorTrade'),
  redirect: '/distributor/order/shop',
  component: View,
  meta: {
    title: '交易管理',
    icon: 'el-icon-caiwu1',
  },
  children: [
    {
      name: name('DistributorTradeOrderAudit'),
      path: 'order/audit',
      component: () => import(/* webpackChunkName: "distributorTrade" */ `@distributor/trade/order/audit/index.vue`),
      meta: {
        title: '订单处理',
      },
    },
    {
      name: name('DistributorTradeOrderHistory'),
      path: 'order/history',
      // component: () => import(/* webpackChunkName: "distributorTrade" */ `@distributor/trade/order/history/index.vue`),
      meta: {
        title: '归档订单',
      },
    },
    {
      name: name('DistributorTradeAfterSale'),
      path: 'after_sale',
      // component: () => import(/* webpackChunkName: "distributorTrade" */ `@distributor/trade/afterSale/index.vue`),
      meta: {
        title: '售后管理',
        // erpHash: '#/aftersale/sale_handle_next/',
        needLogQuery: true,
      },
    },
    {
      name: name('DistributorTradeUploadException'),
      path: 'order/upload_exception',
      // component: () => import(/* webpackChunkName: "distributorTrade" */ `@distributor/trade/order/uploadException.vue`),
      meta: {
        title: '订单跟踪',
        // erpHash: '#/trade/uploadException/',
      },
    },
    {
      name: name('DistributorTradeConfigExpressTemplate'),
      path: 'config/express_template',
      // component: () => import(/* webpackChunkName: "distributorTrade" */ `@distributor/trade/config/expressTemplate.vue`),
      meta: {
        title: '快递模板',
        // 这里菜单路径调整一下，快麦通不支持普通面单
        // erpHash: '#/pt/templateList/?printType=cloud',
      },
    },
    {
      name: name('DistributorTradeConfigAutoMerge'),
      path: 'config/auto_merge',
      // component: () => import(/* webpackChunkName: "distributorTrade" */ `@distributor/trade/config/autoMerge/indexNew.vue`),
      meta: {
        title: '自动化规则',
      },
    },
    {
      name: name('DistributorTradeSyncConf'),
      path: 'after_sale/sync_conf',
      // component: () => import(/* webpackChunkName: "distributorTrade" */ `@distributor/trade/afterSale/syncConf.vue`),
      meta: {
        title: '工单同步配置',
        // erpHash: '#/aftersale/order_sync_conf/',
      }
    },
    {
      name: name('DistributorTradeErpProcess'),
      path: 'order/erp_process',
      meta: {
        title: 'ERP处理',
        navHide: true,
        showWithPath: '/distributor/trade/order/audit',
      }
    },
    {
      name: name('DistributorTradeUploadFail'),
      path: 'order/upload_fail',
      meta: {
        title: '上传失败',
        navHide: true,
        showWithPath: '/distributor/trade/order/audit',
      }
    },
  ],
};

export default trade;
